export const LOGOUT = "LOGOUT";

export const APICONSTANTS = {
    loginpath: ({ PhoneNumber, Password }) => `/Users/Login?PhoneNumber=${PhoneNumber}&Password=${Password}`,
    sigupPath: '/Users/Register',
    forgotPassPath: ({ PhoneNumber }) => `/forgetPassword?PhoneNumber=${PhoneNumber}`,
    ResendOtpPath: ({ PhoneNumber }) => `/ResendPhoneVerification?phone=${PhoneNumber}`,
    verifyOtp: ({ PhoneNumber, Vcode }) => `/Users/Verify?PhoneNumber=${PhoneNumber}&Vcode=${Vcode}`,
    verifyEmail: ({ Vcode }) => `/VerifyEmail?vcode=${Vcode}`,
    updatePasswordPath: "verifyOtpAndResetPassword",
    getUserDetailsPath: "/Users/GetUserProfile",
    updateProfilePath: "/updateProfile",
    updateProfileImagePath: "/changeUserPhoto",
    AddPrebookingTrip: "/AddPrebookingTrip",
    addPrebookingAdvance: "/addPrebookingAdvance",
    getTouristAreas: "getTouristAreas",
    getRehlaNews:"/GetRehlaNews",
    getCarCategories:"/GetCarCategories",
    getDriverTrips: "/getDriverTrips",
    getPassengerReservations: "/getPassengerReservations",
    getAllAdvertisments: "getAllAdvertisments",
    getAllNotification: "/GetAllNotification",
    getRehlaNewsCategories: "/GetRehlaNewsCategories",
    getRehlaNewsByCategory: ({ page = 0, CategoryId }) => `/GetRehlaNews?Page=${page}&CategoryId=${CategoryId}`,
    getMyAllRates: ({ page = 0}) => `/getMyAllRates?Page=${page}`,
    getPrebookingAdvance: (page = 0) => `GetPrebookingAdvance?Page=${page}`,
    getRequestsToSendPackage: (page = 0) => `GetRequestsToSendPackage?Page=${page}`,
   // getMyAllRates: 'getMyAllRates',
    contactUs: "contactUs",
    aboutApplication: "aboutApplication",
    getTermAndConditions: "getTermAndConditions",
    getRatesByUserId:({id})=>`/getAllRatesByUserId?UserId=${id}&Page=1`,
    getAllTransactions: (page = 0) => `GetAllTransactions?Page=${page}`,
    getLanguages: ({page = 0}) => `/GetLanguages?Page=${page}`,
    addTransaction: (CardNumber) => `AddTransaction?CardNumber=${CardNumber}`,
    addWithdrawalRequest: "AddWithdrawalRequest",
    addTourismExpert : "AddTourismExpert",
    getTourismExpertsByAreaId : ({TouristAreaId , page = 0}) => `GetTourismExpertsByAreaId?TouristAreaId=${TouristAreaId}&Page=${page}`,
    getTourismProgramsByAreaId : ({TouristAreaId , page = 0}) => `GetTourismProgramsByAreaId?TouristAreaId=${TouristAreaId}&Page=${page}`,
    getTourismExpertDetails : ({Id,TouristAreaId }) => `GetTourismExpertDetails?Id=${Id}&TouristAreaId=${TouristAreaId}`,
    addTourismReservation : "AddTourismReservation",
    addRequestToSendPackage : "AddRequestToSendPackage",
    myPreferences : "MyPreferences",
    editPreferences : "EditPreferences",
    uploadIdentityImage : "uploadIdentityImage",
    getRehlaNewsDetails : ({id}) => `GetRehlaNewsDetails?id=${id}`,
//  addTransaction: "AddTransaction?CardNumber=09537778862901",
    getBanks: "getBanks",
    DriverComment:"RateADriver"
}
export const ROUTESCONSTANTS = {
    LOGIN: "/login",
    LOGOUT: "/logout",
    REGISTER: "/registration",
    FORGOT_PASSWORD: "/forget-password",
    NEW_PASSWORD: "/new-password",
    EDIT_PROFILE: "/edit-profile",
    HOME: "/",
    SERVICES: "/services",
    CONTACT_US: "/contact-us",
    ABOUT_US: "/about-us",
    FAQ: "/faq",
    PREBOOKING_TRIPS: "/prebooking-trips",
    TOURISM_TOURS: "/tourism-tours",
    NEWS: "/news",
    NEWS_DETAILS: "/news-details",
    VERIFICATION: "/verification",
    PRIVACY_POLICY: "/privacy-policy",
    TERM_OF_USE: "/terms-of-use",
    CITY_TOUR: "/city-tour",
    CITY_TOUR_SINGLE: "/city-tour-single",
    MY_TRIP: "/my-trip",
    MY_RESERVATION: "/my-reservation",
    MY_RATES: "/my-rates",
    NOTIFICATIONS: "/notifications",
    VERIFICATIONS: "/verifications",
    WITHDRAW_BALANCE: "/withdraw-balance",
    MY_WALLET: "/my-wallet",
    MY_SEND_PARCEL: "/my-send-parcel",
    REGISTER_TRAVELER: "/register-traveler",
    BOOK_TOUR: "/book-tour",
    ADD_BALANCE: "/add-balance",
    ADD_BALANCE_FORM: "/add-balance-form",
    MY_PREFERENCE: "/my-preferences"
}